import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=f120c36c&scoped=true&lang=pug&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.scss?vue&type=style&index=0&id=f120c36c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f120c36c",
  null
  
)

export default component.exports